import * as React from "react"

import { cn } from "@/shared/lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> { }

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[100px] w-full rounded-xl border-2 border-visagio-off-white bg-white px-4 py-3 font-body text-sm text-visagio-teal-dark placeholder:text-visagio-gray transition-all duration-200 focus:outline-none focus:border-visagio-teal focus:ring-2 focus:ring-visagio-teal/20 disabled:cursor-not-allowed disabled:opacity-50 whitespace-pre-wrap break-words resize-y",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
